// @flow
import React from 'react';

import { Trans } from 'react-i18next';

import { connectTranslation } from 'middleware/connect';

import { Card } from 'components/layouts';
import { Button } from 'components/buttons';

import { ContactModal } from 'containers/landing';

import { Setting } from './questions.setting';
@connectTranslation()
export class Questions extends Setting {

  render () {
    return (
      <Card className="questions-container">
        <div className="title">
          <Trans i18nKey="landing.questions.title">
            Have questions or suggestions?
          </Trans>
        </div>
        <div className="description">
          <Trans i18nKey="landing.questions.description">
            We’ll answer!
          </Trans>
        </div>
        <Button
          onClick={() => this.setState({ openContactModal: true })}
          outlined
          recruiter>
          <Trans i18nKey="landing.questions.button">
            Write to Us
          </Trans>
        </Button>
        <ContactModal
          open={this.state.openContactModal}
          close={() => this.setState({ openContactModal: false })}/>
      </Card>
    );
  }

}
